__turbopack_context__.v({
  "action": "auth-panel-module-scss-module__yTKpOa__action",
  "alert": "auth-panel-module-scss-module__yTKpOa__alert",
  "bar": "auth-panel-module-scss-module__yTKpOa__bar",
  "check": "auth-panel-module-scss-module__yTKpOa__check",
  "consent": "auth-panel-module-scss-module__yTKpOa__consent",
  "dismiss": "auth-panel-module-scss-module__yTKpOa__dismiss",
  "divider": "auth-panel-module-scss-module__yTKpOa__divider",
  "error": "auth-panel-module-scss-module__yTKpOa__error",
  "field": "auth-panel-module-scss-module__yTKpOa__field",
  "ghost": "auth-panel-module-scss-module__yTKpOa__ghost",
  "heading": "auth-panel-module-scss-module__yTKpOa__heading",
  "icon": "auth-panel-module-scss-module__yTKpOa__icon",
  "input": "auth-panel-module-scss-module__yTKpOa__input",
  "invalid": "auth-panel-module-scss-module__yTKpOa__invalid",
  "label": "auth-panel-module-scss-module__yTKpOa__label",
  "link": "auth-panel-module-scss-module__yTKpOa__link",
  "messages": "auth-panel-module-scss-module__yTKpOa__messages",
  "number": "auth-panel-module-scss-module__yTKpOa__number",
  "otp": "auth-panel-module-scss-module__yTKpOa__otp",
  "panel": "auth-panel-module-scss-module__yTKpOa__panel",
  "primary": "auth-panel-module-scss-module__yTKpOa__primary",
  "provider": "auth-panel-module-scss-module__yTKpOa__provider",
  "providers": "auth-panel-module-scss-module__yTKpOa__providers",
  "resend": "auth-panel-module-scss-module__yTKpOa__resend",
  "screen": "auth-panel-module-scss-module__yTKpOa__screen",
  "sent": "auth-panel-module-scss-module__yTKpOa__sent",
  "spacer": "auth-panel-module-scss-module__yTKpOa__spacer",
  "timer": "auth-panel-module-scss-module__yTKpOa__timer",
  "toast": "auth-panel-module-scss-module__yTKpOa__toast",
});
